// This is compiled by parcel with `npm run build` or `npm run dev`

// Import scripts
import "./src/init-foundation.js"; // initiates foundation js
import "./src/wp-foundation.js"; //
import "./src/lozad.js";
// import "./src/lead-source.js"; // lead source
import "./src/aos.js"; // animations
import "./src/search.js"; //search offcanvas. Can be commented out if not using
import "./src/main.js";

// Imports Individual Component Scripts
import "./../../components/VideoLightbox/scripts.js";
import "./../../components/ProductListingCarousel/scripts.js";
import "./../../components/GalleryWithThumbnails/scripts.js";
import "./../../components/RelatedResources/scripts.js";
import "./../../components/Shortcodes/scripts.js";
import "./../../components/TestimonialsSlider/scripts.js";
import "./../../components/ImageCarousel/scripts.js";

// Import styles

import "./../../node_modules/aos/dist/aos.css";
import "./../../assets/styles/scss/style.scss";
